import { ActionIcon, Box, Tooltip } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCopy } from '@tabler/icons-react';
import React, { useState } from 'react';

interface CopyableCodeBlockProps {
  children: React.ReactNode;
  code: string;
  className?: string;
}

export const CopyableCodeBlock = React.memo<CopyableCodeBlockProps>(
  ({ children, code, className }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(code);
        notifications.show({
          title: 'Copied!',
          message: 'Code copied to clipboard',
          color: 'green',
          autoClose: 2000,
        });
      } catch (error) {
        console.error('Failed to copy code:', error);
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = code;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        notifications.show({
          title: 'Copied!',
          message: 'Code copied to clipboard',
          color: 'green',
          autoClose: 2000,
        });
      }
    };

    return (
      <Box
        className={className}
        style={{ position: 'relative', overflow: 'hidden' }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {children}

        {isHovered && code.trim() && (
          <Tooltip label="Copy code">
            <ActionIcon
              size="sm"
              variant="filled"
              color="gray"
              onClick={handleCopy}
              className="copyable-code-button"
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                zIndex: 100,
                opacity: 0.9,
                backgroundColor: 'var(--mantine-color-gray-8)',
                color: 'white',
                transition: 'opacity 0.2s ease',
              }}
            >
              <IconCopy size={14} />
            </ActionIcon>
          </Tooltip>
        )}
      </Box>
    );
  }
);

CopyableCodeBlock.displayName = 'CopyableCodeBlock';
